import { render, staticRenderFns } from "./show-settings-confirm-msg.vue?vue&type=template&id=97d7e14e&"
import script from "./show-settings-confirm-msg.vue?vue&type=script&lang=js&"
export * from "./show-settings-confirm-msg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports